import React, {useState} from 'react'
import {advancedSearch} from "../../../firebase/getData";
import {Modal, Form, Button, ButtonGroup, Col, Row} from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

//Material UI Stuff
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

export default function AdvancedSearch(props) {
  const [keywords, setKeywords] = useState('');
  const [city, setCity] = useState('');
  const [region, setRegion] = useState('');
  const [country, setCountry] = useState([]);
  const [sector, setSector] = useState([]);
  const [features, setFeatures] = useState([]);
  const [authorName, setAuthorName] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [upvotes, setUpvotes] = useState(undefined);
  const [upvotesComparison, setUpvotesComparison] = useState('Greater than');

  const cleanup = () => {
    setKeywords('');
    setCity('');
    setRegion('');
    setCountry([]);
    setSector([]);
    setFeatures([]);
    setAuthorName('');
    setStartDate(null);
    setEndDate(null);
    setUpvotes(null);
    setUpvotesComparison('');
    props.setShowAdvanced(false);
  }

  const lengthCheckAndUpdate = (e, updateFunction) => {
    if (e.target.value.length <= 100) updateFunction(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();

    let newFeatures = [];
    features.forEach(feat => {
      if (typeof feat !== 'string') newFeatures.push(feat.features);
      else newFeatures.push(feat)
    })

    //Firebase stuff
    advancedSearch({keywords, city, region, country: country[0], 
      sector, features: newFeatures, authorName, startDate, endDate, upvotes, upvotesComparison, 
      setState: props.setState, setLoading: props.setLoading});

    cleanup();
  }
  
  return (
    <div>
      <Modal
      show={props.showAdvanced}
      size="lg"
      onHide={() => cleanup()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Enter any fields you want to search 🔎
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>

            <Form.Group controlId="keywords">
              <Form.Label className="font-weight-bold">Search by keywords ({keywords.length + '/100'})</Form.Label>
              <Form.Control 
                type="text"
                placeholder="Ex. Spice brand" 
                value={keywords} 
                onChange={(e) => lengthCheckAndUpdate(e, setKeywords)}
                />
            </Form.Group>

            <Form.Group controlId="formRegion" className="mt-4">
              <Form.Label className="font-weight-bold">Search by location (please check your spelling)</Form.Label>

              <Row>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridCity">
                  <Form.Text className="text-muted">City ({city.length + '/100'})</Form.Text>
                  <Form.Control 
                    type="text" 
                    placeholder="Ex. Denver" 
                    value={city} 
                    onChange={(e) => lengthCheckAndUpdate(e, setCity)}
                    />
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridRegion">
                  <Form.Text className="text-muted">Region ({region.length + '/100'})</Form.Text>
                  <Form.Control 
                    type="text" 
                    placeholder="Ex. Colorado" 
                    value={region} 
                    onChange={(e) => lengthCheckAndUpdate(e, setRegion)}
                    />
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridCountry">
                  <Form.Text className="text-muted">Country</Form.Text>
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="country"
                      onChange={setCountry}
                      options={countries}
                      placeholder="CLICK on a country"
                      selected={country}
                    />
                </Form.Group>
                </Col>

              </Row>
            </Form.Group>

            <Form.Group controlId="formTags" className="mt-4">
              <Form.Label className="font-weight-bold">Search by industry or features</Form.Label>

              <Row>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridIndustries">
                  <Form.Text className="text-muted">Industry</Form.Text>
                  <Typeahead
                    id="basic-typeahead-single"
                    labelKey="industry"
                    onChange={setSector}
                    options={industries}
                    placeholder="CLICK on industries"
                    selected={sector}
                    multiple
                  />
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="formGridFeatures">
                  <Form.Text className="text-muted">Features</Form.Text>
                  <Typeahead
                    id="basic-typeahead-single"
                    labelKey="features"
                    onChange={setFeatures}
                    options={availableFeatures}
                    placeholder="CLICK on features"
                    selected={features}
                    multiple
                    allowNew
                  />
                </Form.Group>
                </Col>

              </Row>
            </Form.Group>

            <Form.Group controlId="formDates" className="mt-4">
              <Form.Label className="font-weight-bold">Search by Date</Form.Label>

              <Row>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="beginDate">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className="w-100 mb-1"
                      placeholder="YYYY/MM/DD"
                      inputVariant="outlined"
                      variant="inline"
                      format="yyyy/MM/dd"
                      margin="normal"
                      id="date-picker-inline"
                      label="Start Date"
                      value={startDate}
                      onChange={setStartDate}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="endDate">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className="w-100 mb-1"
                      placeholder="YYYY/MM/DD"
                      inputVariant="outlined"
                      variant="inline"
                      format="yyyy/MM/dd"
                      margin="normal"
                      id="date-picker-inline"
                      label="End Date"
                      value={endDate}
                      onChange={setEndDate}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Form.Group>
                </Col>

              </Row>
            </Form.Group>

            <Form.Group controlId="formDates" className="mt-4">
              <Form.Label className="font-weight-bold">Search by Upvotes</Form.Label>

              <Row className="mt-3">

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="comparisonType">
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="upvote-comparison-select">Upvotes are</InputLabel>
                    <Select
                      native
                      value={upvotesComparison}
                      onChange={(e) => setUpvotesComparison(e.target.value)}
                      label="Upvotes are"
                      inputProps={{
                        name: 'upvotes-comparison',
                        id: 'upvote-comparison-select',
                      }}
                    >
                      <option value={'Greater than'}>Greater than</option>
                      <option value={'Less than'}>Less than</option>
                    </Select>
                  </FormControl>
                </Form.Group>
                </Col>

                <Col xl={true} lg={true} md={12} sm={12} xs={12}>
                <Form.Group as={Col} controlId="Number upvotes">
                  <TextField
                    id="outlined-number"
                    placeholder="Ex. 50"
                    label="Number Upvotes"
                    type="number"
                    variant="outlined"
                    className="w-100"
                    onChange={(e) => setUpvotes(e.target.value)}
                  />
                </Form.Group>
                </Col>

              </Row>
            </Form.Group>

            <Form.Group controlId="keywords">
              <Form.Label className="font-weight-bold">Search by author's name ({authorName.length + '/100'})</Form.Label>
              <Form.Control 
                type="text"
                placeholder="Ex. Leonard Tolstoy" 
                value={authorName} 
                onChange={(e) => lengthCheckAndUpdate(e, setAuthorName)}
                />
            </Form.Group>

            <ButtonGroup className="d-flex mt-5">
              <Button block variant="success" onClick={handleSubmit}>Search</Button>
            </ButtonGroup>
      
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const countries = ["United States", "Canada", "Afghanistan","Argentina","Australia","Austria","Bangladesh","Belgium","Brazil","British Virgin Islands","Bulgaria","Chile","China","Colombia","Costa Rica","Cuba","Czech Republic","Denmark","Dominican Republic","Ecuador","Egypt","Estonia","Ethiopia","Finland","France","Germany","Greece","Greenland","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Kenya","Laos","Latvia","Lithuania","Luxembourg","Malaysia","Mexico","Morocco","Nepal","Netherlands","New Zealand","Nigeria","Norway","Pakistan","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Romania","Russia","Rwanda","Saudi Arabia","Serbia","Singapore","South Africa","South Korea","Spain","Sri Lanka","Sweden","Switzerland","Syria","Taiwan","Tanzania","Thailand","Turkey","Uganda","Ukraine","United Arab Emirates","United Kingdom", "Venezuela","Vietnam","Virgin Islands"];
const industries = ["Retail", "Fashion", "Restaurant", "Ecommerce", "Food", "Services", "Household", "Health/Beauty", "Technology"];
const availableFeatures = ["Local", "Organic", "Low/No Waste", "Sustainable Sourcing", "Meat-free", "Reusable", "Low Emissions"];